/**
 * FeatureGrid Organism Component
 * Grid of feature cards with section title
 */

import React from "react";
import { storyblokEditable } from "@/lib/blocks";
import { Container } from "@/components/atoms/Container";
import { Heading } from "@/components/atoms/Heading";
import { Icon } from "@/components/atoms/Icon";
import { FeatureCard } from "@/components/molecules/FeatureCard";
import type { FeatureGridBlok } from "@/types";

export interface FeatureGridProps {
  blok: FeatureGridBlok;
}

export const FeatureGrid: React.FC<FeatureGridProps> = ({ blok }) => {
  const { section_title, section_icon, features, columns = 3 } = blok;

  const gridCols = {
    2: "sm:grid-cols-2",
    3: "sm:grid-cols-2 lg:grid-cols-3",
    4: "sm:grid-cols-2 lg:grid-cols-4",
  };

  return (
    <section
      {...storyblokEditable(blok)}
      id={(blok as {anchor?: string}).anchor || undefined}
      className={`scroll-mt-24 bg-theme-inset py-12 md:py-16 lg:py-20 xl:py-24`}
    >
      <Container>
        {/* Section Header */}
        <div className="flex flex-col items-start gap-4 md:gap-6 mb-4 md:mb-6">
          <div className="p-2 md:p-3 bg-theme-surface rounded-lg">
            <Icon name="feature" size={36} className="text-black dark:text-primary" />
          </div>
          <Heading
            level="h2"
            className="text-black dark:text-primary"
          >
            {section_title}
          </Heading>
        </div>

        {/* Feature Cards Grid */}
        <div
          className={`grid grid-cols-1 ${gridCols[columns]} gap-4 md:gap-6 lg:gap-10`}
        >
          {features &&
            features.map((feature) => (
              <FeatureCard key={feature._uid} {...feature} />
            ))}
        </div>
      </Container>
    </section>
  );
};

export default FeatureGrid;
